import { render, staticRenderFns } from "./TherapistCallBanner.vue?vue&type=template&id=d8418a5e&scoped=true"
import script from "./TherapistCallBanner.vue?vue&type=script&lang=js"
export * from "./TherapistCallBanner.vue?vue&type=script&lang=js"
import style0 from "./TherapistCallBanner.vue?vue&type=style&index=0&id=d8418a5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8418a5e",
  null
  
)

export default component.exports